import React from 'react';
import { motion } from 'framer-motion';
import { process } from '../data/content';
function Process() {
  return (
    <section className="pad" id="process" style={{ background: 'var(--bg-2)' }}>
      <div className="wrap">
        <div className="section-head">
          <span className="eyebrow">How I work</span>
          <h2 className="h-section">A simple, transparent process</h2>
          <p>No black boxes. You always know what I'm building, why, and what's coming next.</p>
        </div>
        <div className="proc-grid">
          {process.map((p, i) => (
            <motion.div className="proc-step" key={p.n} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.08 }}>
              <div className="n">{p.n}</div>
              <h3>{p.title}</h3>
              <p>{p.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
export default Process;
